/**
 * Stripe API endpoints
 */

import axios from 'axios';
import { config } from '@/config/env';

const AZURE_FUNCTIONS_URL = config.azureFunctionsUrl;
const AZURE_FUNCTIONS_KEY = config.azureFunctionsKey;

/**
 * Create Stripe Customer Portal Session
 */
export const createStripePortalSession = async (
  customerId: string,
  returnUrl: string
): Promise<{ url: string }> => {
  const response = await axios.post(
    `${AZURE_FUNCTIONS_URL}/create-stripe-portal-session`,
    {
      customerId,
      returnUrl,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'x-functions-key': AZURE_FUNCTIONS_KEY,
      },
    }
  );

  return response.data;
};
